import { Tag as AntdTag } from 'antd';
import styled from 'styled-components';
import get from 'lodash/get';
import { hexToRGB } from 'util/icwUtility';

export const STATUS = {
  pending: '#B8D819', // Pending Assign (Admin)
  pendingAssign: '#B8D819',
  waitingQuote: '#FFC625',
  quoteAvailable: '#005EFF',
  waiting: '#FFC625', // Waiting to accept (Admin,Inspector)
  waitingAccept: '#FFC625',
  underReview: '#FFC625',
  'waiting for approval': 'FFC625',
  scheduledReject: '#ED4646',
  rejected: '#FF6E58', // Reject schedule (Admin,Inspector reject)
  scheduled: '#005EFF', // Scheduled (Admin,Inspector accept)
  'in-progress': '#005EFF', // In-progress(Admin,Inspector) - after check in
  complete: '#1EC000', // Completed(Admin,Inspector) - after submit
  completed: '#1EC000',
  cancelled: '#ED4646',
  approved: '#005EFF',
  waitingPayment: '#FFC625',
  bookingReserved: '#FFC625',
  pass: '#1EC000', // Validate -PASS
  cap: '#ED4646', // Validate -CAP
  fail: '#ED4646', // Validate -Fail,
  default: '#fff',
  inspectionReleased: '#32C832',
  inspectionReleasedWaiver: '#32C832',
  inspectionRejected: '#FF6E58',
  open: '#32C832',
  active: '#32C832',
  inactive: '#ED4646',
};

const JobStatus = styled(AntdTag)`
  border-radius: 6px;
  border: none;
  font-style: normal;
  font-weight: 500;
  padding: 2px 4px;
  line-height: 14px;
  font-size: 10px;
  background: ${(props) =>
    hexToRGB(get(STATUS, props.status || 'default', STATUS.default), props.alpha || 0.2)};
  color: ${(props) =>
    props.alpha && props.alpha > 0.8
      ? '#ffff'
      : get(STATUS, props.status || 'default', STATUS.default)};
`;

export const JOB_STATUS = {
  pending: 'Pending Assign',
  waiting: 'Waiting To Accept',
  waitingAccept: 'Waiting To Accept',
  waitingQuote: 'Waiting To Accept',
  pendingAssign: 'Pending Assign',
  'waiting for approval': 'Waiting For Approval',
  scheduledReject: 'Schedule Rejected',
  rejected: 'Inspection Rejected',
  scheduled: 'Scheduled',
  inProgress: 'In Progress',
  'in-progress': 'In Progress',
  complete: 'Complete',
  completed: 'Completed',
  cancelled: 'Canceled',
  approved: 'Approved',
  pass: 'Validate -PASS',
  cap: 'Validate -CAP',
  fail: 'Validate -Fail',
  waitingPayment: 'Waiting Payment',
  underReview: 'Under Review',
  bookingReserved: 'Booking Reserved',
  inspectionReleased: 'Inspection Released',
  inspectionReleasedWaiver: 'Inspection Released (Waiver)',
  inspectionRejected: 'Inspection Rejected',
  open: 'Open',
  quoteAvailable: 'Quote Available',
  active: 'Active',
  default: '',
};

export default JobStatus;